<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let menuOpen = false;
  export let color = "black";

  const dispatch = createEventDispatcher();

  function onClick() {
    dispatch("click", {});
  }
</script>

<button
  class="burger-menu flex flex-col lg:hidden"
  class:cross={menuOpen}
  on:click={onClick}
  aria-label="Open navigation drawer"
>
  <span style="background-color:{color}"></span>
  <span style="background-color:{color}"></span>
</button>

<style lang="scss">
  .burger-menu {
    flex-direction: column;
    row-gap: 4px;
    padding: 12px 6px;
    border: 0;
    background: transparent;

    span {
      display: block;
      height: 2px;
      width: 25px;
      background: #000;
    }

    &.cross {
      span:nth-child(1) {
        transform: translateY(3px) rotateZ(-45deg) scaleX(0.9);
      }
      span:nth-child(2) {
        transform: translateY(-3px) rotateZ(45deg) scaleX(0.9);
      }
    }
  }
</style>
